import { render, staticRenderFns } from "./GroupSelectionSessions.vue?vue&type=template&id=da315a18&scoped=true&"
import script from "./GroupSelectionSessions.vue?vue&type=script&lang=js&"
export * from "./GroupSelectionSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da315a18",
  null
  
)

export default component.exports